export const GET_MODIFICHE_DATA = "GET_MODIFICHE_DATA";
export const GET_MODIFICHE_DATA_LOADING = "GET_MODIFICHE_DATA_LOADING";

export const GET_MODIFICHE_DETAILS_DATA = "GET_MODIFICHE_DETAILS_DATA";
export const GET_MODIFICHE_DETAILS_LOADING = "GET_MODIFICHE_DETAILS_LOADING";

export const SET_DOWNLOAD_CSV = "SET_DOWNLOAD_CSV";
export const SET_DOWNLOAD_CSV_FOR_AUDIT_LOG_DETAILS = "SET_DOWNLOAD_CSV_FOR_AUDIT_LOG_DETAILS";